import { Text } from "@sundaeswap/ui-toolkit";
import { FC } from "react";

export const WalletConnectLegalDisclaimer: FC = () => {
  return (
    <Text tag="span" size="xs">
      By connecting a wallet, you agree to the Terms of Service and acknowledge
      that you have read and understand the risks associated with using
      decentralized finance protocols.
    </Text>
  );
};

export default WalletConnectLegalDisclaimer;
